import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars

export default {
    methods: {
        isNumber: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) 
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isNumberWithDecimals: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 48 || charCode > 57) &&
                charCode !== 46 
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isNumberNegative: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (
                charCode > 31 &&
                (charCode < 45 || charCode > 57)
            ) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        valueValidation: function (evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode == 45 || charCode == 101) {
                evt.preventDefault();
            } else {
                return true;
            }
        }
    },
};
